/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Container,
} from "@mui/material";

import {
  Button,
  Notification,
    Divider
} from "components/Atoms";
import { H6 } from 'components/CustomTypography';


import * as Actions from "actions/core/core.actions";

import SellerOrder from "components/elements/seller/SellerOrder";
import ProfileCityEditor from "components/elements/core/ProfileCityEditor";
import MockProductList from "components/elements/main/MockProductList";

import "./styles.scss";
import { getCity, getCountry } from "helpers/utils";

const ProfileCity = (props) => {

  const [state, setState] = useState({ orderMode: "PREVIEW" });
  const [locationState, setLocationState] = useState("");

  const {
    isLoading, cities, countries,
    getCities, getCityLocations,
      history
  } = props;

  useEffect(() => {
    getCities(getCountry().countrycode);
  }, []);

  const onCancel = () => {
    history.push('/');
  };

  const editCity = () => {
    history.push('/');
    getCityLocations(getCity().id);
  };

  const editCountry = (country) => {
    getCities(country);
  };

  const handleOrderEdit = (mode, order, reset) => () => {
    setState({ orderMode: mode });
    if (reset) {
      setLocationState({
        selectedLocation: {
           id: "", city: "", country: ""
        },
      });
    } else {
      setLocationState({
        selectedLocation: {
          id: order.id, city: order.city, country: order.country
        },
      });
    }
  };

  const handlePage = (page) => (e) => {
    props.history.push({
      pathname: page,
    });
  };

  const { orderMode } = state;
  const { selectedLocation = {} } = locationState;

  const renderNoResults = () => (
    <section className="cart-section section-b-space">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div>
              <div className="col-sm-12 empty-cart-cls text-center">
                <H6>No order found
                </H6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const renderLocationEdit = (orderMode) => {
    switch (orderMode) {
      case "EDIT":
      default:
        return (
          <ProfileCityEditor
              setState={(value, field) => setLocationState({
                ...state,
                selectedLocation: {
                  ...selectedLocation,
                  [field]: value,
                },
              })}
              cities={cities}
              countries={countries}
              isLoading={isLoading}
              selectedLocation={selectedLocation}
              updateCityClicked={editCity}
              updateCountryClicked={editCountry}
              onCancel={onCancel}
          />
        );
    }
  };

  return (
    <Container>
      {renderLocationEdit()}
    </Container>
  );
};

ProfileCity.defaultProps = {
  isLoading: false,
  serviceError: "",
  reqStatus: "",
  cities: [],
  countries: [],
  includestatus: true,
};

ProfileCity.propTypes = {
  isLoading: PropTypes.bool,
  serviceError: PropTypes.string,
  reqStatus: PropTypes.string,
  cities: PropTypes.arrayOf(PropTypes.object),
  countries: PropTypes.arrayOf(PropTypes.object),
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  getCities: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
};

const profileCity = connect(
  ({ bootupInfo }) => ({
    bootupInfo,
    reqStatus: bootupInfo.reqStatus,
    isLoading: bootupInfo.isLoading,
    serviceError: bootupInfo.serviceError,
    cities: bootupInfo.cities,
    countries: bootupInfo.countries,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ProfileCity);

export default profileCity;
